import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'workplace', pure: false })
export class WorkplacePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: any, ...args: any[]): any {
    if (!value || typeof value !== 'string' || value.trim() === '') {
      return null;
    }

    const lowerValue = value.toLowerCase();

    if (lowerValue.includes('hybrid') || lowerValue.includes('office_remote')) {
      return this.translate.instant('Vacancies.WorkplaceHybrid');
    }

    if (lowerValue.includes('remote')) {
      return this.translate.instant('Vacancies.WorkplaceRemoteOnly');
    }

    if (
      lowerValue.includes('office') || 
      lowerValue.includes('on-site') || 
      lowerValue.includes('onsite') || 
      lowerValue.includes('on site')
    ) {
      return this.translate.instant('Vacancies.WorkplaceOfficeOnly');
    }

    return this.translate.instant('Vacancies.NotSelected');
  }

}
